export default __webpack_public_path__ + "static/media/blogCategories.49f3394a.svg";